module.exports = __webpack_public_path__ + "14d30fed3bedae08f2f0f2c0a822033f.png";